<template>
    <div class="row">
        <div class="panel panel-primary">
            <div class="panel-heading">
                <h3 class="panel-title">Orders</h3>
            </div>
            <table class="table table-bordered table-striped table-condensed">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Order items</th>
                        <th>Price</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(order, index) in orders">
                        <td>{{ order.id }}</td>
                        <td>
                            <p v-for="orderItem in order.order_items">
                                <img v-if="orderItem.product.images[0]" :src="orderItem.product.images[0].tiny_thumb_url"><br>
                                {{ orderItem.product.name }} {{ orderItem.price | currency }} x {{ orderItem.quantity }} = {{ orderItem.total_price | currency }}
                                <template v-for="variant in orderItem.variants">
                                    <br> <strong>{{ variant.label }}:</strong> {{ variant.value }}
                                </template>
                            </p>
                        </td>
                        <td>{{ order.total_price | currency }}</td>
                        <td>{{ order.status | status }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>


</template>
<script>
    export default {
        data: function () {
            return {
                orders: []
            }
        },

        mounted() {
            this.getOrders();
        },

        methods: {
            getOrders() {
                axios.get('/api/v1/orders/member').then((response) => {
                    this.orders = _.map(response.data, (order) => {
                        order.total_price = _.sumBy(order.order_items, 'total_price');
                        return order;
                    });
                }).catch((error) => {
                    this.$message({message: 'There was a problem loading yout orders.', type: 'error'});
                });
            }
        },

        filters: {
            status(value) {
                return _.startCase(value);
            }
        }
    }
</script>
